export const INSTRUCTOR_TBD_NAME_FLAG = "None";
